import 'parsleyjs';

$(function() {
    $('.parsley-form').each(function () {
        $(this).parsley();
    });
});
